'use strict';

module.exports = {
    intersectionObserver: 'IntersectionObserver',
    keyCodes: {
        enter: 13,
        esc: 27
    },

    selectors: {
        isInitialState: '.isInitialState',
        isSectionShown: '.isSectionShown'
    },

    cssClasses: {
        isShow: 'isShow',
        isShown: 'isShown',
        isHide: 'isHide',
        isActive: 'isActive',
        isSuccess: 'isSuccess',
        isAnimation: 'isAnimation',
        isPlaying: 'isPlaying',
        isPlayed: 'isPlayed',
        isError: 'isError',
        isAbsolute: 'isAbsolute',
        isFixed: 'isFixed',
        isDisabled: 'isDisabled',
        isScrolled: 'isScrolled',
        isInitialState: 'isInitialState',
        isSectionShown: 'isSectionShown',
        isImmediateShow: 'isImmediateShow',
        isDark: 'isDark',
        isPendingToHide: 'isPendingToHide',
        isShowContentWithoutBackground: 'isShowContentWithoutBackground',
        disableTransition: 'disableTransition'
    },

    cssProperties: {
        opacity: 'opacity',
        fill: 'fill',
        overflow: 'overflow',
        transform: 'transform',
        zIndex: 'z-index'
    }
};
